import styled from '@emotion/styled'
import type { MouseEventHandler } from 'react'

import { Card } from '@/legacy/components/Card'
import { BodyP } from '@/legacy/components/Typography'
import { CONFIG } from '@/ui/shared/styles'

export interface CardProps {
  modifier: 'large' | 'default' | 'horizontal'
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

export const Container = styled(Card)<CardProps>`
  display: flex;
  flex-direction: column;
  width: 18.5rem;
  height: 26.5rem;

  &:hover {
    box-shadow: var(--theme-box-shadow) !important;
  }

  img {
    object-fit: cover;
  }

  .blog-card__content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 0.5rem 1rem;
    margin-top: -0.75rem;
    height: 100%;
    gap: 0.5rem;

    ${CONFIG.media.mobileLg} {
      .blog-card__cover {
        display: none;
      }
    }

    ${CONFIG.media.lg} {
      .blog-card__cover {
        height: 40%;
      }
    }
  }

  .skeleton__wrapper {
    margin: 1rem 0;
  }

  .blog-card__footer {
    margin: 0.75rem auto;

    .eu-al-center {
      gap: 1.25rem;
    }
    svg {
      transform: translateX(0);
      transition: var(--theme-transition) transform;
    }
  }

  .blog-card__footer:hover {
    svg {
      transform: translateX(50%);
      transition: var(--theme-transition) transform;
    }
  }

  &:hover {
    box-shadow: unset;
  }
`

export const DateWrapper = styled(BodyP)`
  display: flex;
  justify-content: space-between;

  &.skeleton__wrapper {
    margin: 2rem 0 0;
  }
`
